import { DELIVERY_ADDRESS, DELIVERY_METHOD } from "@/model/delivery";
import { ProductDeliveryMethodInterface } from "@/model/components/ProductDeliveryMethodInterface";

export const mapDeliveryMethod: Function = (
  deliveryAddress: typeof DELIVERY_ADDRESS[keyof typeof DELIVERY_ADDRESS],
  productDeliveryMethod: ProductDeliveryMethodInterface
): object => {
  switch (true) {
    case deliveryAddress === DELIVERY_ADDRESS.AT_THE_STORE:
      return {
        deliveryMethod: "",
        deliveryTime: ""
      };

    case productDeliveryMethod.deliveryMethod === DELIVERY_METHOD.YAMATO:
      return {
        deliveryMethod: productDeliveryMethod.deliveryMethod,
        deliveryTime: productDeliveryMethod.timeDesignation
      };

    default:
      return {
        deliveryMethod: productDeliveryMethod.deliveryMethod,
        deliveryTime: ""
      };
  }
};
